import FeatherIcon from 'feather-icons-react';
import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next';
import '../sass/displayUnitEdit.scss';
import { Col, Row } from 'react-bootstrap';
import warningIcon from '../../../../../../../assets/img/icons/warning-small.png';
import { measureConverter, } from '../../../../../../../_services/common.service';


const EditSimulateShelf = ({
    isRTL,
    dmode,
    distanceFromTop,
    mapFields,
    svgdrawDiemention,
    svgViewId,
    catDivHeight,
    wrapperId = "simulation-edit-wrapper", // Default wrapper ID
    setShowConfigurationBox,
    setSelectedShelf,
    selectedShelf,
    setDepthValue,
    setSSpaceValue,
    setFFloorValue,
    setThicknessValue,
    onShelfClick, // Callback when a shelf is clicked
    pegBoardList,
    mapProducts, // Product list to display
    topProductHeights,
    onShelfPropertyChange, // Handler for property changes
    displayRatio, // Display ratio for calculations
    spacefromtopsvgdraw,
    IsShowStackables,
    selectedScProductId,
    displayUOM,
    stepStartPoint = 0, // Starting point for step calculation (future: from field.shelfStartPoint)
    stepSize = 5 // Step size in cm (future: from field.defaultGap)
}) => {
    const {t} = useTranslation();
    const containerRef = useRef(null);
    const svgContainerRef = useRef(null);
    const [containerWidth, setContainerWidth] = useState(svgdrawDiemention.drawWidth);
    const [hoveredShelf, setHoveredShelf] = useState(null);

    // Drag state
    const [isDragging, setIsDragging] = useState(false);
    const [dragStartY, setDragStartY] = useState(null);
    const [draggedShelf, setDraggedShelf] = useState(null);
    const [tempShelfY, setTempShelfY] = useState(null);
    const [isInRestrictedArea, setIsInRestrictedArea] = useState(false); // Track if drag is in restricted area
    const initialShelfYRef = useRef(null); // Store initial Y position

    // Temporary values during drag for real-time display
    const [tempShelfHeight, setTempShelfHeight] = useState(null); // S.Space value during drag
    const [tempFromFloor, setTempFromFloor] = useState(null); // From Floor value during drag
    const [tempBelowHeight, setTempBelowHeight] = useState(null); // Height of shelf below during drag

    const duEditTopPanelStyle = {
        height:distanceFromTop,
    }

    const duEditSimulatePanelStyle = {
        border:'0px solid #000',
        width: '100%',
        // overflowX: 'scroll', // Always show horizontal scrollbar
        // overflowY: 'auto'
    }

    // Snap value to nearest step
    // field: the field object (in future will contain shelfStartPoint and defaultGap)
    // value: the value to snap (in cm)
    // Returns: snapped value aligned to step grid
    const snapToStep = (field, value) => {
        // Future implementation: use field.shelfStartPoint and field.defaultGap
        // const startPoint = field?.shelfStartPoint ?? stepStartPoint;
        // const step = field?.defaultGap ?? stepSize;

        // Current implementation: use props
        const startPoint = stepStartPoint;
        const step = stepSize;

        // Calculate offset from starting point
        const offset = value - startPoint;

        // Round to nearest step
        const snappedOffset = Math.round(offset / step) * step;

        // Return snapped value
        return startPoint + snappedOffset;
    };

    // Recalculate product Y positions based on updated shelf positions
    const getAdjustedProductPosition = (product) => {
        if (!product || !mapFields) return { x: product.x, y: product.y };

        // Find the field this product belongs to
        const fieldKey = product.field_custom_id || product.fieldId;
        const field = mapFields[fieldKey];

        if (!field || !field.shelf || !product.shelfrank) {
            return { x: product.x, y: product.y };
        }

        // Find the shelf this product belongs to
        const shelf = field.shelf.find(s => s.rank === product.shelfrank);

        if (!shelf) {
            return { x: product.x, y: product.y };
        }

        // Check if this shelf is currently being dragged
        const isShelfBeingDragged = isDragging &&
                                    draggedShelf &&
                                    draggedShelf.fieldKey === fieldKey &&
                                    draggedShelf.rank === shelf.rank;

        // Use temporary Y position if shelf is being dragged, otherwise use actual position
        const shelfY = isShelfBeingDragged && tempShelfY !== null ? tempShelfY : shelf.y;

        // Calculate the product's Y position relative to the shelf
        // Products sit on top of the shelf (shelf.y is the top of the shelf)
        return {
            // x: shelf.x  + product.startingPoint * displayRatio,
            y: (shelfY + shelf.drawHeight) - ( measureConverter(product.uom,displayUOM,product.height) * displayRatio), // Position product on top of shelf
            x: product.x,
            drawWidth: measureConverter(product.uom,displayUOM,product.width) * displayRatio,
            drawHeight: measureConverter(product.uom,displayUOM,product.height) * displayRatio,
        };
    }


    // Calculate "from the floor" value for the selected shelf
    // This calculates the sum of heights and gaps of all shelves below the selected shelf
    const calculateFromFloorValue = (allField, selectedShelf) => {
        if (!allField || !selectedShelf || !displayRatio) {
            return 0;
        }

        const originalFromFloor = allField.drawHeight - (Math.abs(allField.y - selectedShelf.y) + selectedShelf.drawHeight + selectedShelf.drawGap);
        return originalFromFloor > 0 ? safeRound(originalFromFloor/displayRatio) : 0;
        
        // // OLD
        // const allShelves = allField.shelf;
        // const currentShelfRank = selectedShelf.rank;

        // // Sum up the drawHeight and drawGap of all shelves below the current shelf
        // let fromFloorValue = 0;

        // for (let i = 0; i < allShelves.length; i++) {
        //     const shelf = allShelves[i];
        //     // Only include shelves with rank greater than current shelf (shelves below it)
        //     if (shelf.rank > currentShelfRank) {
        //         fromFloorValue += shelf.drawHeight + shelf.drawGap;
        //     }
        // }
        // return fromFloorValue / displayRatio;
    };

    // Update container width when svgdrawDiemention changes
    useEffect(() => {
        setContainerWidth(svgdrawDiemention.drawWidth);
    }, [svgdrawDiemention.drawWidth]);

    useEffect(() => {
        let cleanupFunction = null;
        let retryCount = 0;
        const maxRetries = 10;
        const retryInterval = 500;

        const initializeScrollSync = () => {
            const mainSvgWrapper = document.getElementById(wrapperId);
            const shelfSvgContainer = svgContainerRef.current;
            
            if (!mainSvgWrapper || !shelfSvgContainer) {
                if (retryCount < maxRetries) {
                    retryCount++;
                    console.log(`EditSimulateShelf: Elements not found, retrying... (${retryCount}/${maxRetries})`);
                    setTimeout(initializeScrollSync, retryInterval);
                    return;
                } else {
                    console.log('EditSimulateShelf: Max retries reached, could not initialize scroll sync');
                    return;
                }
            }

            let isScrollingSelf = false;

            // Handle main SVG scroll - update shelf SVG
            const handleMainScroll = (event) => {
                if (isScrollingSelf) return;
                
                isScrollingSelf = true;
                const { scrollLeft, scrollTop } = event.target;
                shelfSvgContainer.scrollLeft = scrollLeft;
                shelfSvgContainer.scrollTop = scrollTop;
                
                requestAnimationFrame(() => {
                    isScrollingSelf = false;
                });
            };

            // Handle shelf SVG scroll - update main SVG  
            const handleShelfScroll = (event) => {
                if (isScrollingSelf) return;
                
                isScrollingSelf = true;
                const { scrollLeft, scrollTop } = event.target;
                mainSvgWrapper.scrollLeft = scrollLeft;
                mainSvgWrapper.scrollTop = scrollTop;
                
                requestAnimationFrame(() => {
                    isScrollingSelf = false;
                });
            };

            // Add event listeners
            mainSvgWrapper.addEventListener('scroll', handleMainScroll, { passive: true });
            shelfSvgContainer.addEventListener('scroll', handleShelfScroll, { passive: true });

            // Set cleanup function
            cleanupFunction = () => {
                if (mainSvgWrapper) {
                    mainSvgWrapper.removeEventListener('scroll', handleMainScroll);
                }
                if (shelfSvgContainer) {
                    shelfSvgContainer.removeEventListener('scroll', handleShelfScroll);
                }
            };
        };

        // Start initialization
        initializeScrollSync();

        // Cleanup
        return () => {
            if (cleanupFunction) {
                cleanupFunction();
            }
        };
    }, [svgViewId, wrapperId]);

    // Safe rounding function to avoid floating point issues
    const safeRound = (num, precision = 2) => {
        const factor = Math.pow(10, precision)
        return Math.round((num + Number.EPSILON) * factor) / factor
    }

    // Select the specific shelf by cursor
     const handleShelfSelect = (field, fieldKey, shelf, event) => {
        if (event) {
            event.stopPropagation();
        }
        const selectedShelfDetail = { fieldKey, rank: shelf.rank, shelf, field };
        setSelectedShelf(selectedShelfDetail);
        setDepthValue(field.depth);
        setSSpaceValue(shelf.height);
        setFFloorValue(0);
        setThicknessValue(shelf.gap);
        const originalFromFloor = field.drawHeight - (Math.abs(field.y - shelf.y) + shelf.drawHeight + shelf.drawGap);
        setFFloorValue(originalFromFloor > 0 ? safeRound(originalFromFloor/displayRatio) : 0);

        if (setShowConfigurationBox) {
            setShowConfigurationBox(true);
        }
    };

    // Deselect shelf when clicking outside with in svg
    const handleCanvasClick = () => {
        if (setShowConfigurationBox) {
            setShowConfigurationBox(false);
        }
        setSelectedShelf(null);
    };

    // Handle shelf drag start
    const handleShelfMouseDown = (field, fieldKey, shelf, event) => {
        if (event) {
            event.stopPropagation();
            event.preventDefault();
        }

        // Select the shelf first
        handleShelfSelect(field, fieldKey, shelf, event);

        // Check if this is the last shelf - cannot drag the last shelf
        const isLastShelf = shelf.rank === field.shelf[field.shelf.length - 1].rank;
        if (isLastShelf) {
            console.warn('Cannot drag the last shelf');
            return;
        }

        // Start dragging
        setIsDragging(true);
        setDragStartY(event.clientY);
        setDraggedShelf({ fieldKey, rank: shelf.rank, field, shelf });
        setTempShelfY(shelf.y);
        initialShelfYRef.current = shelf.y; // Store the initial Y position
    };

    // Add global mouse event listeners for drag
    useEffect(() => {
        const MIN_SHELF_HEIGHT = 5; // cm - minimum height a shelf can have

        const handleMouseMove = (event) => {
            if (!isDragging || !draggedShelf || initialShelfYRef.current === null) return;

            const deltaY = event.clientY - dragStartY;
            const newY = initialShelfYRef.current + deltaY; // Calculate from initial position

            // Get the field and shelf data
            const field = mapFields[draggedShelf.fieldKey];
            if (!field || !field.shelf) return;

            const shelfIndex = field.shelf.findIndex(s => s.rank === draggedShelf.rank);
            if (shelfIndex === -1) return;

            const currentShelf = field.shelf[shelfIndex];
            const shelfBelow = shelfIndex < field.shelf.length - 1 ? field.shelf[shelfIndex + 1] : null;
            const shelfAbove = shelfIndex > 0 ? field.shelf[shelfIndex - 1] : null;

            // Calculate boundaries - must match handleShelfPropertyChange validation
            let isRestricted = false;

            // Calculate the new "From Floor" value based on drag position
            const deltaYInCm = deltaY / displayRatio;

            // Calculate current fromFloor value (sum of all shelves below)
            let currentFromFloor = 0;
            for (let i = shelfIndex + 1; i < field.shelf.length; i++) {
                currentFromFloor += field.shelf[i].drawHeight + field.shelf[i].drawGap;
            }
            currentFromFloor = currentFromFloor / displayRatio;

            // When dragging down (deltaY positive), fromFloor decreases
            // When dragging up (deltaY negative), fromFloor increases
            const rawNewFromFloor = currentFromFloor - deltaYInCm;

            // Apply magnetic snapping to nearest step
            const newFromFloor = snapToStep(field, rawNewFromFloor);

            // Calculate the new height of the current shelf
            // The fromFloorDifference tells us how much the shelf moved
            const fromFloorDifference = newFromFloor - currentFromFloor;
            const newHeight = currentShelf.height - fromFloorDifference;
            const newDrawHeight = newHeight * displayRatio;
            const heightDifference = newHeight - currentShelf.height;

            // Check if this shelf has products by looking in topProductHeights
            const shelfHasProducts = topProductHeights?.find(
                item => item.fieldId === field.actualFieldId && item.shelfRank === currentShelf.rank
            );

            // Determine minimum height based on whether products exist
            let effectiveMinHeight = MIN_SHELF_HEIGHT;

            if (shelfHasProducts && shelfHasProducts.topHeight) {
                // Shelf has products - calculate minimum shelf height based on product height
                // topHeight = maximum product height on this shelf (in draw units)
                // Product Y position = shelf.y + shelf.drawHeight - topHeight

                const maxProductHeight = shelfHasProducts.topHeight;

                // Compare in draw units: newDrawHeight vs maxProductHeight
                if (newDrawHeight < maxProductHeight) {
                    isRestricted = true;
                    console.warn(`Cannot adjust: shelf height would be less than product height`);
                }
            }

            // Check if there's a shelf below - same validation as handleShelfPropertyChange
            if (shelfBelow) {
                const newBelowHeight = shelfBelow.height - heightDifference;

                // IMPORTANT: Check both conditions separately to match handleShelfPropertyChange
                if (newBelowHeight < MIN_SHELF_HEIGHT) {
                    isRestricted = true;
                }
                if (newHeight < MIN_SHELF_HEIGHT) {
                    isRestricted = true;
                }

                // CRITICAL: Check if shelf below has products that would be crushed
                const shelfBelowHasProducts = topProductHeights?.find(
                    item => item.fieldId === field.actualFieldId && item.shelfRank === shelfBelow.rank
                );

                if (shelfBelowHasProducts && shelfBelowHasProducts.topHeight) {
                    // Shelf below has products - validate that reducing its height won't crush products
                    const maxProductHeightBelow = shelfBelowHasProducts.topHeight;
                    const newBelowDrawHeight = newBelowHeight * displayRatio;

                    // Compare in draw units
                    if (newBelowDrawHeight < maxProductHeightBelow) {
                        isRestricted = true;
                        console.warn(`Cannot adjust: shelf below height would be less than its product height`);
                    }
                }
            } else {
                // No shelf below - cannot modify (last shelf)
                isRestricted = true;
            }

            // Update temporary position and values for visual feedback
            setTempShelfY(newY);
            setIsInRestrictedArea(isRestricted);
            setTempShelfHeight(newHeight);
            setTempFromFloor(newFromFloor);
            if (shelfBelow) {
                const newBelowHeight = shelfBelow.height - heightDifference;
                setTempBelowHeight(newBelowHeight);
            }
        };

        const handleMouseUp = (event) => {
            if (!isDragging || !draggedShelf) return;

            const deltaY = event.clientY - dragStartY;
            const deltaYInCm = deltaY / displayRatio;

            // Calculate the new "From Floor" value based on the drag
            const field = mapFields[draggedShelf.fieldKey];
            const shelfIndex = field.shelf.findIndex(s => s.rank === draggedShelf.rank);

            if (field && shelfIndex !== -1 && onShelfPropertyChange && displayRatio) {
                // Calculate current fromFloor value (sum of all shelves below)
                let currentFromFloor = 0;
                for (let i = shelfIndex + 1; i < field.shelf.length; i++) {
                    currentFromFloor += field.shelf[i].drawHeight + field.shelf[i].drawGap;
                }
                currentFromFloor = currentFromFloor / displayRatio;

                // When dragging down (deltaY positive), fromFloor decreases
                // When dragging up (deltaY negative), fromFloor increases
                const rawNewFromFloor = currentFromFloor - deltaYInCm;

                // Snap to nearest step on drop
                const snappedFromFloor = snapToStep(field, rawNewFromFloor);

                // Use the existing validation and recalculation logic
                if (snappedFromFloor > 0) {
                    onShelfPropertyChange('fromFloor', snappedFromFloor);
                }
            }

            // Reset drag state
            setIsDragging(false);
            setDragStartY(null);
            setDraggedShelf(null);
            setTempShelfY(null);
            setIsInRestrictedArea(false); // Reset warning state
            initialShelfYRef.current = null; // Reset initial position
            setTempShelfHeight(null); // Reset temporary height
            setTempFromFloor(null); // Reset temporary from floor
            setTempBelowHeight(null); // Reset temporary below height
        };

        if (isDragging) {
            window.addEventListener('mousemove', handleMouseMove);
            window.addEventListener('mouseup', handleMouseUp);

            return () => {
                window.removeEventListener('mousemove', handleMouseMove);
                window.removeEventListener('mouseup', handleMouseUp);
            };
        }
    }, [isDragging, dragStartY, tempShelfY, draggedShelf, mapFields, onShelfPropertyChange, displayRatio, isInRestrictedArea]);

    

    // Horizontal scrollbar ref for synchronization
    const horizontalScrollbarRef = useRef(null);

    // Sync scrollbar with container
    useEffect(() => {
        const container = svgContainerRef.current;
        const scrollbar = horizontalScrollbarRef.current;

        if (!container || !scrollbar) return;

        const handleContainerScroll = () => {
            scrollbar.scrollLeft = container.scrollLeft;
        };

        const handleScrollbarScroll = () => {
            container.scrollLeft = scrollbar.scrollLeft;
        };

        container.addEventListener('scroll', handleContainerScroll);
        scrollbar.addEventListener('scroll', handleScrollbarScroll);

        return () => {
            container.removeEventListener('scroll', handleContainerScroll);
            scrollbar.removeEventListener('scroll', handleScrollbarScroll);
        };
    }, []);

    const setLableWidth = (drawwidthfield)=>{
        let retunval=0
        let maxWidth=250
        let lowWidth=25
        var percentageWidth=drawwidthfield*0.60
        if(lowWidth>percentageWidth){
            retunval=lowWidth
        }else if(maxWidth<percentageWidth){
            retunval=maxWidth
        }else{
            retunval=percentageWidth
        }
        return retunval
    }

    const validateProductHeightOld = (product) => {
            
        for (let field of Object.values(mapFields)) {
            if (field.field_custom_id === product.field_custom_id) {
                for (let shelf of field.shelf) {
                    if (shelf.rank === product.shelfrank) {
                        //const maxProductCount = Math.floor(measureConverter(shelf.uom, displayUOM, shelf.height) / measureConverter(product.uom, displayUOM, product.height)) // NEW CODE WITH UOM CONVERTER
                        const maxProductCount = Math.floor(shelf.height / product.height);  //OLD CODE (NOT CHECKING UOM HERE)
                        if( product.stackCount >= maxProductCount) {
                            return maxProductCount -1
                        }else{
                            return product.stackCount
                        }
                    }
                }
            }
        }
        return false;
    };

    // Pegboard Product Placement Enhancement CR - 2026 APRIL
    const validateProductHeight = (product) => {

        if (!mapFields) return false;
        // PLAN-783 - Fixed this bug
        const field = mapFields[product.field_custom_id];

        if (!field) return false;

        let behindTotalShelfHeight = 0;

        for (let shelf of field.shelf) {
            // Skip maxProductCount calculation for shelves that are behind a pegboard
            const isBehindPegboard = pegBoardList && pegBoardList.some(peg =>
                peg.pegDrawingRect?.fieldIDs?.includes(field.actualFieldId) &&
                peg.pegDrawingRect?.shelfIDs?.includes(shelf.rank)
            );

            if (isBehindPegboard) {
                behindTotalShelfHeight += measureConverter(shelf.uom, displayUOM, shelf.height);
            }else{
                behindTotalShelfHeight = shelf.height; // Reset if the shelf is not behind a pegboard
            }


            if (shelf.rank === product.shelfrank) {

                const maxProductCount = Math.floor(measureConverter(shelf.uom, displayUOM, behindTotalShelfHeight) / measureConverter(product.uom, displayUOM, product.height));
                if (product.stackCount >= maxProductCount) {
                    return maxProductCount - 1;
                } else {
                    return product.stackCount;
                }
            }
        }
        return false;
    };

    const validateProductFieldHeightOld = (product) => {
        const fieldLists = mapFields;

        if (!fieldLists) return false;

        for (let field of Object.values(fieldLists)) {
            if (field.field_custom_id === product.field_custom_id) {
                for (let shelf of field.shelf) {
                    if (shelf.rank === product.shelfrank) {
                        const maxProductCount = Math.floor(measureConverter(shelf.uom, displayUOM, shelf.height) / measureConverter(product.uom, displayUOM, product.height)) // NEW CODE WITH UOM CONVERTER
                        return maxProductCount;
                    }
                }
            }
        }
        return false;
    }

    // Pegboard Product Placement Enhancement CR - 2026 APRIL
    const validateProductFieldHeight = (product) => {
    
        if (!mapFields) return false;

        const field = mapFields[product.field_custom_id];
        if (!field) return false;

        let accumulatedHeight = 0;
        let currentPegGroup = null;

        for (let shelf of field.shelf) {

            // Find pegboards that match this field + shelf
            const matchingPegs = pegBoardList?.filter(peg =>
                peg.pegDrawingRect?.fieldIDs?.includes(field.actualFieldId) &&
                peg.pegDrawingRect?.shelfIDs?.includes(shelf.rank)
            ) || [];

            const isBehindPegboard = matchingPegs.length > 0;

            // If shelf is behind pegboard
            if (isBehindPegboard) {

                // Identify pegboard group (use peg id or unique key)
                const pegGroupId = matchingPegs.map(p => p.id).join(',');

                // If switching pegboard group → reset
                if (currentPegGroup !== pegGroupId) {
                    accumulatedHeight = 0;
                    currentPegGroup = pegGroupId;
                }

                accumulatedHeight += shelf.height;

            } else {
                // Not behind pegboard → treat independently
                accumulatedHeight = shelf.height;
                currentPegGroup = null;
            }

            // Check target shelf
            if (shelf.rank === product.shelfrank) {

                const maxProductCount = Math.floor(
                    measureConverter(shelf.uom, displayUOM, accumulatedHeight) /
                    measureConverter(product.uom, displayUOM, product.height)
                );

                return maxProductCount;
            }
        }
        return false;
    };

    // Check if shelf aligns with shelf positions 
    const isShelfAlignedWithDots = (field, shelf) => {
        if (!field.simulationDefaultGap) return true; // If no gaps defined, don't mark as misaligned

        const gapInDrawUnits = field.simulationDefaultGap * displayRatio;
        const tolerance = 2; // Allow 2px tolerance for alignment

        // Calculate the bottom of the shelf (y + drawHeight)
        const shelfBottom = shelf.y + shelf.drawHeight;

        // Use simulationShelfStartPoint from the bottom upward, or default to field bottom
        const fieldBottom = field.y + field.drawHeight;
        const startPoint = field.simulationShelfStartPoint
            ? (fieldBottom - (field.simulationShelfStartPoint * displayRatio))
            : fieldBottom;

        // Calculate available height from start point to top of field
        const availableHeight = startPoint - field.y;
        const dotCount = Math.floor(availableHeight / gapInDrawUnits);

        for (let i = 0; i <= dotCount; i++) {
            const dotY = startPoint - (i * gapInDrawUnits);
            const difference = Math.abs(shelfBottom - dotY);
            const isMatch = difference <= tolerance;

            if (isMatch) {
                return true;
            }
        }

        return false;
    };


    return (
        <React.Fragment>
            <div style={{ position: 'relative', width: '100%', height: '100%' }}>
                <div className="du-edit-panel-top" style={duEditTopPanelStyle}></div>
                <div
                    className="du-edit-simulation-panel"
                    style={duEditSimulatePanelStyle}
                    ref={svgContainerRef}
                >
                <Col className='du-simulate-section'>
                    <Col className="du-simulate-section-child">
                        <Row>
                            <Col>
                                <Col className='du-middle-section' style={{ padding: 0}}>
                                {/* Simulation content */}
                                <React.Fragment>
                                    {(mapFields && Object.keys(mapFields).length > 0) &&
                                    <Col className="du-single-sim-item" onContextMenu={e => e.preventDefault()} style={{width: `${svgdrawDiemention.drawWidth}px`}}>
                                        <svg 
                                            id={`${svgViewId}-shelf`} 
                                            viewBox={"0 0 "+svgdrawDiemention.drawWidth+" "+catDivHeight} 
                                            width={svgdrawDiemention.drawWidth} 
                                            height={catDivHeight}
                                            onClick={handleCanvasClick}
                                            style={{
                                                display: 'block',
                                                width: `${svgdrawDiemention.drawWidth}px`,
                                                height: `${catDivHeight}px`,
                                                marginLeft: '20px',
                                                marginRight: '-20px',
                                            }}
                                            // style={{border: '0px solid rgb(81, 40, 160)'}}
                                            // onMouseDown={(e) => this.svgMouseDown(e)} 
                                            // onMouseMove={(e)=>this.svgMouseMove(e)} 
                                            // onMouseUp={(e) => this.svgMouseUp(e)}
                                            // ref={(ref) => this.drawSVG = ref} 
                                            version="1.1" 
                                            preserveAspectRatio="none" 
                                            xmlns="http://www.w3.org/2000/svg">
                                            {/* className={this.state.cursorChangeToPeg === true ? 'peg-enable':'peg-disable'}>
                                            */}
                                            {/* SHOWING FIELD DIMENSION - 2026 JAN*/}
                                            {(mapFields && Object.keys(mapFields).length > 0) && Object.keys(mapFields).map((fld, f) => {
                                                var Afld = mapFields[fld];
                                                return<React.Fragment key={f}>
                                                    <rect 
                                                        width = {setLableWidth(Afld.drawWidth)} 
                                                        height = {spacefromtopsvgdraw} 
                                                        x = {Afld.x} 
                                                        y = {(Afld.y-spacefromtopsvgdraw) } 
                                                        fill = "#5128A0" 
                                                    />
                                                    <text 
                                                        fill={"white"} 
                                                        x={(Afld.x+3) } 
                                                        y={(Afld.y-6)} 
                                                        style={{ fontSize: "10px" }}
                                                        className="small catnametag">
                                                            {Afld.fieldName}
                                                    </text>
                                                </React.Fragment>
                                            })}
                                            
                                            {(mapFields && Object.keys(mapFields).length > 0) && Object.keys(mapFields).map((Fld, f) => {
                                                var fld = mapFields[Fld];
                                                const fieldKey = fld.field_custom_id ?? fld.fieldId ?? Fld;
                                                return<React.Fragment key={f}>
                                                    {/* field left border */}
                                                    <line
                                                        x1={fld.x}
                                                        y1={fld.y}
                                                        x2={fld.x}
                                                        y2={fld.y + fld.drawHeight}
                                                        stroke={dmode?'#2CC990':'#5128a0'}
                                                        strokeWidth={4}
                                                        pointerEvents="none"
                                                    />
                                                    
                                                    {/* field right border */}
                                                    <line
                                                        x1={fld.x + fld.drawWidth}
                                                        y1={fld.y}
                                                        x2={fld.x + fld.drawWidth}
                                                        y2={fld.y + fld.drawHeight}
                                                        stroke={dmode?'#2CC990':'#5128a0'}
                                                        strokeWidth={4}
                                                        pointerEvents="none"
                                                    />

                                                    {/* field top border  */}
                                                    <line
                                                        x1={fld.x}
                                                        y1={fld.y}
                                                        x2={fld.x + fld.drawWidth}
                                                        y2={fld.y}
                                                        stroke={dmode?'#2CC990':'#5128a0'}
                                                        strokeWidth={1}
                                                        pointerEvents="none"
                                                    />

                                                    

                                                    {/* field shelf */}
                                                    {fld.shelf.length > 0 ? fld.shelf.map((shlf, g) => {
                                                        const isHovered = hoveredShelf?.fieldKey === fieldKey && hoveredShelf?.rank === shlf.rank;
                                                        const isSelected = selectedShelf?.fieldKey === fieldKey && selectedShelf?.rank === shlf.rank;
                                                        const isBeingDragged = isDragging && draggedShelf?.fieldKey === fieldKey && draggedShelf?.rank === shlf.rank;
                                                        const isLastShelf = shlf.rank === fld.shelf[fld.shelf.length - 1].rank;

                                                        // Calculate Y position (use temp position if being dragged)
                                                        const displayY = isBeingDragged && tempShelfY !== null ? tempShelfY : shlf.y;

                                                        // Create a shelf object with the display Y position for alignment check
                                                        const shelfForAlignment = {
                                                            ...shlf,
                                                            y: displayY
                                                        };

                                                        // Check if shelf is aligned with dot positions
                                                        const isAligned = isShelfAlignedWithDots(fld, shelfForAlignment);

                                                        const shelfColor = dmode ? '#2CC990' : '#5128A0';
                                                        const shelfActiveColor = '#F39C12';
                                                        const shelfMisalignedColor = '#ff0000'; // Red for misaligned shelves

                                                        // Priority: restricted > misaligned (but not for last shelf) > active > normal
                                                        const appliedColor = isBeingDragged && isInRestrictedArea ? '#ff0000'
                                                            : (!isAligned && !isLastShelf) ? shelfMisalignedColor
                                                            : (isSelected || isHovered || isBeingDragged) ? shelfActiveColor
                                                            : shelfColor;

                                                        return (
                                                        <React.Fragment key={g}>

                                                            <rect
                                                                width={shlf.drawWidth}
                                                                height={shlf.drawGap}
                                                                x={shlf.x}
                                                                y={(displayY + 0) + (shlf.drawHeight ? shlf.drawHeight : 0)}
                                                                style={{
                                                                    strokeWidth: isBeingDragged && isInRestrictedArea ? 2 : 1,
                                                                    stroke: isBeingDragged && isInRestrictedArea ? '#ff0000' : appliedColor,
                                                                    fill: isBeingDragged && isInRestrictedArea ? '#ff000080' : appliedColor,
                                                                    cursor: isDragging ? 'grabbing' : 'grab',
                                                                    opacity: isBeingDragged ? 0.7 : 1
                                                                }}
                                                                onMouseEnter={() => setHoveredShelf({ fieldKey, rank: shlf.rank })}
                                                                onMouseLeave={() => setHoveredShelf(null)}
                                                                onClick={(event) => handleShelfSelect(fld, fieldKey, shlf, event)}
                                                                onMouseDown={(event) => handleShelfMouseDown(fld, fieldKey, shlf, event)}
                                                            />

                                                            {/* Warning icon when dragging in restricted area */}
                                                            {isBeingDragged && isInRestrictedArea && (
                                                                <image
                                                                    href={warningIcon}
                                                                    x={shlf.x + shlf.drawWidth / 2 - 15}
                                                                    y={displayY + (shlf.drawHeight ? shlf.drawHeight : 0) - 35}
                                                                    width={30}
                                                                    height={30}
                                                                />
                                                            )}

                                                            const originalFromFloor = selectedShelf.field.drawHeight - (selectedShelf.shelf.y + selectedShelf.shelf.drawHeight + selectedShelf.shelf.drawGap);

                                                            {/* <g onClick={() => onShelfClick && onShelfClick(shlf)} style={{cursor: 'pointer'}}>
                                                                <text
                                                                    x={isRTL === "rtl" ? shlf.x + (shlf.drawWidth * 3.4 / 4) : shlf.x + (shlf.drawWidth * 1 / 4)}
                                                                    y={shlf.rank === fld.shelf[fld.shelf.length - 1].rank ? (shlf.y + 0) + (shlf.drawHeight ? shlf.drawHeight : 0) + (shlf.drawGap / 2) - 10 : (shlf.y + 0) + (shlf.drawHeight ? shlf.drawHeight : 0) + (shlf.drawGap / 2) + 15}
                                                                    fontSize="10"
                                                                    fill="#ebe2e2ff"
                                                                    textAnchor="middle"
                                                                >D {Math.trunc(fld.depth)}</text>

                                                                <text
                                                                    x={isRTL === "rtl" ? shlf.x + (shlf.drawWidth * 2.6 / 4) : shlf.x + (shlf.drawWidth * 1.8 / 4)}
                                                                    y={shlf.rank === fld.shelf[fld.shelf.length - 1].rank ? (shlf.y + 0) + (shlf.drawHeight ? shlf.drawHeight : 0) + (shlf.drawGap / 2) - 10 : (shlf.y + 0) + (shlf.drawHeight ? shlf.drawHeight : 0) + (shlf.drawGap / 2) + 15}
                                                                    fontSize="10"
                                                                    fill="#ebe2e2ff"
                                                                    textAnchor="middle"
                                                                >S {Math.trunc(shlf.height)}</text>

                                                                <text
                                                                    x={isRTL === "rtl" ? shlf.x + (shlf.drawWidth * 1.8 / 4) : shlf.x + (shlf.drawWidth * 2.6 / 4)}
                                                                    y={shlf.rank === fld.shelf[fld.shelf.length - 1].rank ? (shlf.y + 0) + (shlf.drawHeight ? shlf.drawHeight : 0) + (shlf.drawGap / 2) - 10 : (shlf.y + 0) + (shlf.drawHeight ? shlf.drawHeight : 0) + (shlf.drawGap / 2) + 15}
                                                                    fontSize="10"
                                                                    fill="#ebe2e2ff"
                                                                    textAnchor="middle"
                                                                >F {Math.trunc(fld.drawHeight - (Math.abs(fld.y - shlf.y) + shlf.drawHeight + shlf.drawGap))}</text>

                                                                 <text
                                                                    x={isRTL === "rtl" ? shlf.x + (shlf.drawWidth * 1 / 4) : shlf.x + (shlf.drawWidth * 3.4 / 4)}
                                                                    y={shlf.rank === fld.shelf[fld.shelf.length - 1].rank ? (shlf.y + 0) + (shlf.drawHeight ? shlf.drawHeight : 0) + (shlf.drawGap / 2) - 10 : (shlf.y + 0) + (shlf.drawHeight ? shlf.drawHeight : 0) + (shlf.drawGap / 2) + 15}
                                                                    fontSize="10"
                                                                    fill="#ebe2e2ff"
                                                                    textAnchor="middle"
                                                                >T {Math.trunc(shlf.gap)}</text>
                                                            </g> */}

                                                        </React.Fragment>
                                                        );
                                                    }):<></>}

                                                    {/* Shelf placement holes (dots) on the left side */}
                                                    {/* {fld.simulationDefaultGap && (() => {
                                                        const gapInDrawUnits = fld.simulationDefaultGap * displayRatio;

                                                        // Use simulationShelfStartPoint from the bottom upward, or default to field bottom
                                                        const fieldBottom = fld.y + fld.drawHeight;
                                                        const startPoint = fld.simulationShelfStartPoint
                                                            ? (fieldBottom - (fld.simulationShelfStartPoint * displayRatio))
                                                            : fieldBottom;

                                                        // Calculate available height from start point to top of field
                                                        const availableHeight = startPoint - fld.y;
                                                        const dotCount = Math.floor(availableHeight / gapInDrawUnits);
                                                        const dots = [];

                                                        for (let i = 0; i <= dotCount; i++) {
                                                            const dotY = startPoint - (i * gapInDrawUnits);
                                                            if (dotY >= fld.y) {
                                                                dots.push(
                                                                    <rect
                                                                        key={`dot-${i}`}
                                                                        x={fld.x - 2}
                                                                        y={dotY - 1}
                                                                        width={4}
                                                                        height={2}
                                                                        fill={dmode ? '#2CC990' : '#f9f8fb'}
                                                                        opacity={1}
                                                                    />
                                                                );
                                                            }
                                                        }
                                                        return dots;
                                                    })()} */}
                                                </React.Fragment>
                                            })}

                                                
                                            {/* Showing shelf top product indicator line */}
                                            {(!mapFields && Object.keys(mapFields).length > 0) && Object.keys(mapFields).map((Fld, f) => {
                                                var fld = mapFields[Fld]; 
                                                return (
                                                    fld.shelf.length > 0 ? fld.shelf.map((shlf, g) => {
                                                    //Get the top product height for this shelf
                                                   const topProductHeight = topProductHeights?.find(item => item.fieldId === fld.actualFieldId && item.shelfRank === shlf.rank);

                                                     if (topProductHeight && topProductHeight?.topHeight > 0) {
                                                        // Calculate Y position for the top product height line
                                                        return (<React.Fragment key={g}>
                                                            <line
                                                                x1={shlf.x}
                                                                y1={topProductHeight?.topHeight}
                                                                x2={shlf.x + shlf.drawWidth}
                                                                y2={topProductHeight?.topHeight}
                                                                stroke="#000000ff"
                                                                strokeWidth={1}
                                                                pointerEvents="none"
                                                                strokeDasharray={[3,3]} 
                                                                onClick={() => onShelfClick && onShelfClick(shlf)}
                                                            />

                                                        </React.Fragment>)
                                                    }
                                                }):<></>
                                            );
                                            })} 

                                            {/* Showing products for each field */}
                                            {mapProducts && mapProducts.length > 0 && mapProducts.map((product, prodIndex) => {
                                                // Skip deleted or hanged products
                                                if (product?.isDelete || product?.isHanged) {
                                                    return null;
                                                }

                                                // Get adjusted position based on current shelf positions
                                                const adjustedPos = getAdjustedProductPosition(product);

                                                return (
                                                    <React.Fragment key={prodIndex}>
                                                        <image
                                                            id={product?.id}
                                                            pointerEvents="all"
                                                            preserveAspectRatio="none"
                                                            x={adjustedPos.x}
                                                            y={adjustedPos.y}
                                                            width={adjustedPos.drawWidth}
                                                            height={adjustedPos.drawHeight}
                                                            href={product.imageUrl}
                                                            style={{ outline: product?.mark_height_issue === true ? "solid 4px red" : (product.isStackable && IsShowStackables) ? selectedScProductId === product.productId ? dmode ? "solid 2px #2CC990" : "solid 2px #5128a0" : "solid 1px #ED327A" : selectedScProductId === product.productId ? dmode ? "solid 2px #2CC990" : "solid 2px #5128a0" : "solid 1px rgb(204, 204, 204)"}}
                                                        />
                                                    </React.Fragment>
                                                );
                                                    
                                            })}

                                            

                                            {/* Showing meta tag */}
                                             {(mapFields && Object.keys(mapFields).length > 0) && Object.keys(mapFields).map((Fld, f) => {
                                                var fld = mapFields[Fld];
                                                const fieldKey = fld.field_custom_id ?? fld.fieldId ?? Fld;
                                                return<React.Fragment key={f}>
                                                    {/* field shelf */}
                                                    {fld.shelf.length > 0 ? fld.shelf.map((shlf, g) => {
                                                        // Check if this shelf is currently being dragged
                                                        const isBeingDragged = isDragging && draggedShelf?.fieldKey === fieldKey && draggedShelf?.rank === shlf.rank;

                                                        // Check if this is the shelf below the one being dragged
                                                        const shelfIndex = fld.shelf.findIndex(s => s.rank === shlf.rank);
                                                        const isShelfBelowDragged = isDragging &&
                                                                                    draggedShelf?.fieldKey === fieldKey &&
                                                                                    shelfIndex > 0 &&
                                                                                    fld.shelf[shelfIndex - 1].rank === draggedShelf?.rank;

                                                        // Use temporary Y position if being dragged, otherwise use actual position
                                                        const displayY = isBeingDragged && tempShelfY !== null ? tempShelfY : shlf.y;

                                                        // Use temporary values during drag
                                                        const displayHeight = isBeingDragged && tempShelfHeight !== null ? tempShelfHeight :
                                                                             isShelfBelowDragged && tempBelowHeight !== null ? tempBelowHeight :
                                                                             shlf.height;
                                                        const displayFromFloor = isBeingDragged && tempFromFloor !== null ? tempFromFloor :
                                                                                calculateFromFloorValue(fld, shlf);

                                                        return (
                                                        <React.Fragment key={g}>

                                                            <g onClick={() => onShelfClick && onShelfClick(shlf)} style={{cursor: 'pointer'}}>
                                                                <text
                                                                    x={isRTL === "rtl" ? shlf.x + (shlf.drawWidth * 3.4 / 4) : shlf.x + (shlf.drawWidth * 1 / 4)}
                                                                    y={shlf.rank === fld.shelf[fld.shelf.length - 1].rank ? (displayY + 0) + (shlf.drawHeight ? shlf.drawHeight : 0) + (shlf.drawGap / 2) - 10 : (displayY + 0) + (shlf.drawHeight ? shlf.drawHeight : 0) + (shlf.drawGap / 2) + 15}
                                                                    // fill="#ebe2e2ff"
                                                                    fill="#fff"
                                                                    stroke="#000"
                                                                    strokeWidth="1"
                                                                    paintOrder="stroke fill"
                                                                    textAnchor="middle"
                                                                    className='meta-label'
                                                                >D {Math.trunc(fld.depth)}</text>

                                                                <text
                                                                    x={isRTL === "rtl" ? shlf.x + (shlf.drawWidth * 2.6 / 4) : shlf.x + (shlf.drawWidth * 1.8 / 4)}
                                                                    y={shlf.rank === fld.shelf[fld.shelf.length - 1].rank ? (displayY + 0) + (shlf.drawHeight ? shlf.drawHeight : 0) + (shlf.drawGap / 2) - 10 : (displayY + 0) + (shlf.drawHeight ? shlf.drawHeight : 0) + (shlf.drawGap / 2) + 15}
                                                                    // fill="#ebe2e2ff"
                                                                    fill="#fff"
                                                                    stroke="#000"
                                                                    strokeWidth="1"
                                                                    paintOrder="stroke fill"
                                                                    textAnchor="middle"
                                                                    className='meta-label'
                                                                >S {Math.round(displayHeight)}</text>

                                                                <text
                                                                    x={isRTL === "rtl" ? shlf.x + (shlf.drawWidth * 1.8 / 4) : shlf.x + (shlf.drawWidth * 2.6 / 4)}
                                                                    y={shlf.rank === fld.shelf[fld.shelf.length - 1].rank ? (displayY + 0) + (shlf.drawHeight ? shlf.drawHeight : 0) + (shlf.drawGap / 2) - 10 : (displayY + 0) + (shlf.drawHeight ? shlf.drawHeight : 0) + (shlf.drawGap / 2) + 15}
                                                                    // fill="#ebe2e2ff"
                                                                    fill="#fff"
                                                                    stroke="#000"
                                                                    strokeWidth="1"
                                                                    paintOrder="stroke fill"
                                                                    textAnchor="middle"
                                                                    className='meta-label'
                                                                >F {Math.trunc(displayFromFloor)}</text>

                                                                 <text
                                                                    x={isRTL === "rtl" ? shlf.x + (shlf.drawWidth * 1 / 4) : shlf.x + (shlf.drawWidth * 3.4 / 4)}
                                                                    y={shlf.rank === fld.shelf[fld.shelf.length - 1].rank ? (displayY + 0) + (shlf.drawHeight ? shlf.drawHeight : 0) + (shlf.drawGap / 2) - 10 : (displayY + 0) + (shlf.drawHeight ? shlf.drawHeight : 0) + (shlf.drawGap / 2) + 15}
                                                                    // fill="#ebe2e2ff"
                                                                    fill="#fff"              // text color
                                                                    stroke="#000"            // border/outline color
                                                                    strokeWidth="1"          // outline thickness
                                                                    paintOrder="stroke fill" // draw border behind fill
                                                                    textAnchor="middle"
                                                                    className='meta-label'
                                                                >T {Math.trunc(shlf.gap)}</text>
                                                            </g>

                                                        </React.Fragment>
                                                        );
                                                    }):<></>}
                                                </React.Fragment>
                                            })}

                                            {/* Showing peg boards if field list have peg boards */}
                                            {pegBoardList && pegBoardList.length > 0 && pegBoardList.map((peg, p) => {
                                                return<React.Fragment key={p}>
                                                    <rect 
                                                        key={peg?.id}
                                                        x={peg?.pegDrawingRect?.drawX} 
                                                        y={peg?.pegDrawingRect?.drawY} 
                                                        width={peg?.pegDrawingRect?.drawRectWidth} 
                                                        height={peg?.pegDrawingRect?.drawRectHeight} 
                                                        fill="#ffffffff" 
                                                        stroke="#000000ff" 
                                                        strokeDasharray={[2,2]} 
                                                        strokeWidth={2}>
                                                    </rect>

                                                    
                                                    <text 
                                                        x={isRTL === 'ltr' ? peg?.pegDrawingRect?.drawX + peg?.pegDrawingRect?.drawRectWidth / 2 : peg?.pegDrawingRect?.drawX + peg?.pegDrawingRect?.drawRectWidth / 2} 
                                                        y={peg?.pegDrawingRect?.drawY + peg?.pegDrawingRect?.drawRectHeight / 2} 
                                                        fontSize="15" 
                                                        fontWeight="bold" 
                                                        fill="#a1a1a1ff" 
                                                        textAnchor="middle"
                                                    >{isRTL === 'ltr' ? t('PEG_BOARD')+' '+peg.name : peg.name+' '+t('PEG_BOARD')}</text> 

                                                    <line
                                                        x1={peg?.pegDrawingRect?.drawX}
                                                        y1={peg?.pegDrawingRect?.drawY}
                                                        x2={(peg?.pegDrawingRect?.drawX + peg?.pegDrawingRect?.drawRectWidth)}
                                                        y2={(peg?.pegDrawingRect?.drawY + peg?.pegDrawingRect?.drawRectHeight)}
                                                        stroke={dmode?'#2CC990':'#000000ff'}
                                                        strokeWidth={1}
                                                        strokeDasharray={[2,2]} 
                                                        pointerEvents="none"
                                                    />

                                                    <line
                                                        x1={peg?.pegDrawingRect?.drawX + peg?.pegDrawingRect?.drawRectWidth}
                                                        y1={peg?.pegDrawingRect?.drawY}
                                                        x2={(peg?.pegDrawingRect?.drawX)}
                                                        y2={(peg?.pegDrawingRect?.drawY + peg?.pegDrawingRect?.drawRectHeight)}
                                                        stroke={dmode?'#2CC990':'#000000ff'}
                                                        strokeWidth={1}
                                                        strokeDasharray={[2,2]} 
                                                        pointerEvents="none"
                                                    />

                                                </React.Fragment>
                                            })}

                                            {/* Showing product has stack products */}
                                            {mapProducts && mapProducts.length > 0 && mapProducts.map((product, prodIndex) => {
                                                // Skip deleted or hanged products
                                                if (product?.isDelete || product?.isHanged) {
                                                    return null;
                                                }

                                                // Get adjusted position based on current shelf positions
                                                const adjustedPos = getAdjustedProductPosition(product);
                                                const maxProductCount = validateProductHeight(product);
                                                const maxHeigth = validateProductFieldHeight(product);

                                                return (
                                                    <React.Fragment key={prodIndex}>
                                                        {product?.isStackable && IsShowStackables && (
                                                            maxHeigth === 1 ? (
                                                                <foreignObject
                                                                x={adjustedPos.x + (adjustedPos.drawWidth / 2) - 7}
                                                                y={adjustedPos.y - 12}
                                                                width={adjustedPos.drawWidth}
                                                                height={20}
                                                                >
                                                                <div style={{ textAlign: "center" }}>
                                                                    <FeatherIcon
                                                                    icon="chevrons-up"
                                                                    color="#ED327A"
                                                                    size={14}
                                                                    />
                                                                </div>
                                                                </foreignObject>
                                                            ) : (
                                                                <>
                                                                {Array.from({ length: maxProductCount }).map((_, stackIndex) => (
                                                                    <image
                                                                    key={stackIndex}
                                                                    id={`${product?.id}_stack_${stackIndex}`}
                                                                    pointerEvents="all"
                                                                    preserveAspectRatio="none"
                                                                    x={adjustedPos.x}
                                                                    y={
                                                                        adjustedPos.y -
                                                                        (stackIndex + 1) * adjustedPos.drawHeight
                                                                    }
                                                                    width={adjustedPos.drawWidth}
                                                                    height={adjustedPos.drawHeight}
                                                                    href={product.imageUrl}
                                                                    style={{ outline: "solid 1px #ED327A" }}
                                                                    />
                                                                ))}
                                                                </>
                                                            )
                                                        )}
                                                    </React.Fragment>
                                                );
                                            })}
                                        </svg>
                                    </Col>
                                    }
                                </React.Fragment>
                                </Col>
                            </Col>
                        </Row>
                    </Col>
                </Col>

            </div>
            </div>
        </React.Fragment>
    )
}
        

export default EditSimulateShelf;
